const degItem = Math.PI / 180
export interface IWatermarkOptions {
  text: string
  family: string
  color: string
  lineHeight: number
  rotate: number
  gutterX: number
  gutterY: number
  fontSize: number
  width: number
  height: number
  offsetX: number
  offsetY: number
}

export default function (canvas: HTMLCanvasElement, options: Partial<IWatermarkOptions> = {}) {
  const {
    text = '',
    family = 'normal',
    lineHeight = 1,
    rotate = 0,
    gutterX = 0,
    gutterY = 0,
    fontSize = 16,
    color = '#d4d5ff',
    width = 0,
    height = 0,
    offsetX = 0,
    offsetY = 0,
  } = options
  if (!text) {
    return console.error('text is required!')
  }
  const deg = degItem * rotate
  const ctx = canvas.getContext('2d')
  if (!ctx) {
    return console.error('context2d is null!')
  }
  const content = text.split('\n')
  canvas.width = width
  canvas.height = height

  ctx.save()
  ctx.font = `${fontSize}px ${family}`
  const contentWidth = content.reduce((p, t) => Math.max(p, ctx.measureText(t).width), 0)
  const contentHeight = fontSize * lineHeight * content.length
  const contentOuterWidth = contentWidth + gutterX
  const contentOuterHeight = contentHeight + gutterY
  ctx.restore()

  const xCount = Math.ceil(canvas.width / contentOuterWidth) + 1
  const yCount = Math.ceil(canvas.height / (contentHeight + gutterY)) + 1
  const lineHeightPixel = fontSize * lineHeight
  for (let x = 0; x < xCount; x++) {
    const pointX = contentOuterWidth * (x - 0.5) + offsetX
    let pointY = contentHeight * -1.5 + offsetY
    for (let y = 0; y < yCount; y++) {
      ctx.save()
      pointY += contentOuterHeight
      ctx.fillStyle = color
      ctx.font = `${fontSize}px ${family}`
      ctx.textBaseline = 'top'
      ctx.translate(pointX, pointY)
      ctx.rotate(deg)
      content.forEach((t, i) => {
        const itemY = lineHeightPixel * i + -contentHeight / 2
        ctx.fillText(t, -contentWidth / 2, itemY)
      })
      ctx.restore()
    }
  }
}
